import { MULTIPLE_VALUES_IN_URL_SEPARATOR } from "shared/utils/constants";
import { GetSearchFilterValueConfig } from "./types";

export function getSearchFilterValue({ name, searchParams, isMulti }: GetSearchFilterValueConfig) {
  const filterValue = searchParams.get(name);
  if (!filterValue) {
    return null;
  }
  return isMulti ? filterValue?.split(MULTIPLE_VALUES_IN_URL_SEPARATOR) : filterValue;
}
